import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0B] border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-transparent bg-gradient-to-r from-[#FF6B35] to-[#F7931E] bg-clip-text font-bold text-lg mb-4">IPTV4KFR</h3>
            <p className="text-[#E8E8E8]/70 text-sm">
              Plateforme IPTV premium offrant une expérience complète de divertissement, simple et accessible sur tous vos écrans.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/offre" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Notre Offre
                </Link>
              </li>
              <li>
                <Link to="/telechargements" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Téléchargements
                </Link>
              </li>
              <li>
                <Link to="/tutoriels" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Tutoriels et assistance
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/devenir-vendeur" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Devenir Vendeur
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/mentions-legales" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  CGU Clients
                </Link>
              </li>
              <li>
                <Link to="/cgu-vendeurs" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  CGU Vendeurs
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="text-[#E8E8E8]/70 hover:text-[#FF6B35] transition-colors text-sm">
                  Confidentialité
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-[#E8E8E8]/70 text-sm">
                <Mail className="h-4 w-4 text-[#FF6B35]" />
                <span>contact@iptv4kfr.fr</span>
              </li>
              <li className="flex items-center space-x-2 text-[#E8E8E8]/70 text-sm">
                <Phone className="h-4 w-4 text-[#FF6B35]" />
                <span>Support Telegram</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-[#E8E8E8]/50 text-sm">
            © 2026 IPTV4KFR - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;